import React, { useState } from "react";
import "./form2.css";
import { useNavigate } from "react-router-dom";

const Formta2 = ({ formData, setFormData, setStep }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value.trim() !== "") {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    let newErrors = {};
    console.log(formData);
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "தேர்ந்தெடுக்கவும்";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBack = () => {
    setStep(1);
  };

  const HandleNext = (e) => {
    e.preventDefault();
    if (validateForm()) {
      navigate(setStep(3));
    }
  };

  const renderError = (field) =>
    errors[field] ? <span className="error-text">{errors[field]}</span> : null;

  return (
    <>
      <div className="form2-background">
        <div className="form2-section">
          <h2 className="form2-title">தனிப்பட்ட விவரங்கள்(2/7)</h2>
          <form>
            <div className="form2-grid">
              <div className="form2-group">
                <label>
                  சுயவிவர வகை<span className="error fs-star">*</span>
                </label>
                <select
                  name="profileCategory"
                  value={formData.profileCategory}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                     <option value="">Select</option>
                  <option value="Farmer, Business">Farmer Business</option>
                  <option value="Government Job">Government Job</option>
                  <option value="Private Job">Private Job</option>
                  <option value="IT Job">IT Job</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Own Business">Own Business</option>
                  <option value="VIP">VIP</option>
                  <option value="VVIP">VVIP</option>
                  <option value="Foreign">Foreign</option>
                </select>
                {renderError("profileCategory")}
              </div>

              <div className="form2-group">
                <label>
                  கல்வி<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="education"
                  placeholder="கல்வியை உள்ளிடவும்"
                  value={formData.education}
                  onChange={handleChange}
                />
                {renderError("education")}
              </div>

              <div className="form2-group">
                <label>
                  இரத்த வகை<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="bloodGroup"
                  placeholder="இரத்த வகையை உள்ளிடவும்"
                  value={formData.bloodGroup}
                  onChange={handleChange}
                />
                {renderError("bloodGroup")}
              </div>
              <div className="form2-group">
                <label>
                  உடல் அமைப்பு <span className="error fs-star">*</span>
                </label>
                <select
                  name="BodyType"
                  value={formData.BodyType}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="Slim">ஒல்லி</option>
                  <option value="Average">சராசரி</option>
                  <option value="Fat">குண்டான</option>
                  <option value="Fit">ஆரோக்கியமான</option>
                  <option value="Lean">மிதமான ஒல்லி</option>
                </select>
                {renderError("BodyType")}
              </div>

              <div className="form2-group">
                <label>
                  வேலை விவரம்<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="jobDescription"
                  placeholder="வேலை விவரத்தை உள்ளிடவும்"
                  value={formData.jobDescription}
                  onChange={handleChange}
                />
                {renderError("jobDescription")}
              </div>

              <div className="form2-group">
                <label>
                  மாத வருமானம்<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="monthlyIncome"
                  placeholder="மாத வருமானத்தை உள்ளிடவும்"
                  value={formData.monthlyIncome}
                  onChange={handleChange}
                />
                {renderError("monthlyIncome")}
              </div>

              <div className="form2-group">
                <label>
                  வேலை இடம்<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="workPlace"
                  placeholder="வேலை இடத்தை உள்ளிடவும்"
                  value={formData.workPlace}
                  onChange={handleChange}
                />
                {renderError("workPlace")}
              </div>
              <div className="form2-group">
                <label>
                  கடவுச்சொல் <span className="error fs-star">*</span>
                </label>
                <input
                  type="password"
                  name="password"
                  placeholder="கடவுச்சொல்லை உள்ளிடவும்"
                  value={formData.password}
                  onChange={handleChange}
                />
                {renderError("password")}
              </div>

              <div className="form2-group">
                <label>
                  சாதி<span className="error fs-star">*</span>
                </label>
                <select
                  name="caste"
                  value={formData.caste}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="கொங்கு வெள்ளாள கவுண்டர்">கொங்கு வெள்ளாள கவுண்டர்</option>
                  <option value="கொங்கு வேளாளர் உட்பிரிவு">கொங்கு வேளாளர் உட்பிரிவு</option>
                  <option value="கொங்கு வேளாளர் கலப்பு">கொங்கு வேளாளர் கலப்பு</option>
                </select>

                {renderError("caste")}
              </div>

              <div className="form2-group">
                <label>
                  குலம்<span className="error fs-star">*</span>
                </label>
                <select
                  name="kulam"
                  value={formData.kulam}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="அந்துவன் குலம்">அந்துவன் குலம்</option>
                  <option value="அழகன் குலம்">அழகன் குலம்</option>
                  <option value="ஆட குலம்">ஆட குலம்</option>
                  <option value="ஆதி குலம்">ஆதி குலம்</option>
                  <option value="ஆந்தை குலம்">ஆந்தை குலம்</option>
                  <option value="ஆவ குலம்">ஆவ குலம்</option>
                  <option value="ஆவின் குலம்">ஆவின் குலம்</option>
                  <option value="ஈஞ்சன் குலம்">ஈஞ்சன் குலம்</option>
                  <option value="எண்ணை குலம்">எண்ணை குலம்</option>
                  <option value="ஒழுக்க குலம்">ஒழுக்க குலம்</option>
                  <option value="ஓதாலன் குலம்">ஓதாலன் குலம்</option>
                  <option value="கணக்கன் குலம்">கணக்கன் குலம்</option>
                  <option value="கணவாளன் குலம்">கணவாளன் குலம்</option>
                  <option value="கண்ணந்தை குலம்">கண்ணந்தை குலம்</option>
                  <option value="கண்ணன் குலம்">கண்ணன் குலம்</option>
                  <option value="களிஞ்சி குலம்">களிஞ்சி குலம்</option>
                  <option value="காடை குலம்">காடை குலம்</option>
                  <option value="காரி குலம்">காரி குலம்</option>
                  <option value="கீரன் குலம்">கீரன் குலம்</option>
                  <option value="குயிலர் குலம்">குயிலர் குலம்</option>
                  <option value="குழையர் குலம்">குழையர் குலம்</option>
                  <option value="கூறை குலம்">கூறை குலம்</option>
                  <option value="கோவேந்தர் குலம்">கோவேந்தர் குலம்</option>
                  <option value="சாத்தந்தை குலம்">சாத்தந்தை குலம்</option>
                  <option value="சிலம்பன் குலம்">சிலம்பன் குலம்</option>
                  <option value="செங்கண்ணன் குலம்">செங்கண்ணன் குலம்</option>
                  <option value="செங்குண்ணி குலம்">செங்குண்ணி குலம்</option>
                  <option value="செம்பன் குலம்">செம்பன் குலம்</option>
                  <option value="செம்பூத்தான் குலம்">செம்பூத்தான் குலம்</option>
                  <option value="செல்லன் குலம்">செல்லன் குலம்</option>
                  <option value="செவ்வந்தி குலம்">செவ்வந்தி குலம்</option>
                  <option value="செவ்வாய் குலம்">செவ்வாய் குலம்</option>
                  <option value="சேடன் குலம்">சேடன் குலம்</option>
                  <option value="சேரன் குலம்">சேரன் குலம்</option>
                  <option value="சேரலன் குலம்">சேரலன் குலம்</option>
                  <option value="சோழன் குலம்">சோழன் குலம்</option>
                  <option value="தனஞ்செயன் குலம்">தனஞ்செயன் குலம்</option>
                  <option value="தழிஞ்சி குலம்">தழிஞ்சி குலம்</option>
                  <option value="தூரன் குலம்">தூரன் குலம்</option>
                  <option value="தேவேந்திரன் குலம்">தேவேந்திரன் குலம்</option>
                  <option value="தோடை குலம்">தோடை குலம்</option>
                  <option value="நீருண்ணியர் குலம்">நீருண்ணியர் குலம்</option>
                  <option value="பண்ணை குலம்">பண்ணை குலம்</option>
                  <option value="பதரியர் குலம்">பதரியர் குலம்</option>
                  <option value="பதுமன் குலம்">பதுமன் குலம்</option>
                  <option value="பனங்காடை குலம்">பனங்காடை குலம்</option>
                  <option value="பனையன் குலம்">பனையன் குலம்</option>
                  <option value="பயிரன் குலம்">பயிரன் குலம்</option>
                  <option value="பவழ குலம்">பவழ குலம்</option>
                  <option value="பாண்டியன் குலம்">பாண்டியன் குலம்</option>
                  <option value="பிரழந்தை குலம்">பிரழந்தை குலம்</option>
                  <option value="பில்லன் குலம்">பில்லன் குலம்</option>
                  <option value="பூசன் குலம்">பூசன் குலம்</option>
                  <option value="பூச்சந்தை குலம்">பூச்சந்தை குலம்</option>
                  <option value="பூந்தன் குலம்">பூந்தன் குலம்</option>
                  <option value="பெரிய குலம்">பெரிய குலம்</option>
                  <option value="பெருங்குடி குலம்">பெருங்குடி குலம்</option>
                  <option value="பொடியன் குலம்">பொடியன் குலம்</option>
                  <option value="பொன்னர் குலம்">பொன்னர் குலம்</option>
                  <option value="பொருள்தந்த குலம்">பொருள்தந்த குலம்</option>
                  <option value="மணியன் குலம்">மணியன் குலம்</option>
                  <option value="மயிலர் குலம்">மயிலர் குலம்</option>
                  <option value="மாட குலம்">மாட குலம்</option>
                  <option value="முத்தன் குலம்">முத்தன் குலம்</option>
                  <option value="முல்லை குலம்">முல்லை குலம்</option>
                  <option value="முழுக்காதன் குலம்">முழுக்காதன் குலம்</option>
                  <option value="மூலன் குலம்">மூலன் குலம்</option>
                  <option value="மேதி குலம்">மேதி குலம்</option>
                  <option value="வண்ணக்கன் குலம்">வண்ணக்கன் குலம்</option>
                  <option value="வில்லி குலம்">வில்லி குலம்</option>
                  <option value="விளையன் குலம்">விளையன் குலம்</option>
                  <option value="வெண்டுவன் குலம்">வெண்டுவன் குலம்</option>
                  <option value="வெண்ணை குலம்">வெண்ணை குலம்</option>
                  <option value="வெளியன் குலம்">வெளியன் குலம்</option>
                  <option value="வெள்ளம்பன் குலம்">வெள்ளம்பன் குலம்</option>
                  <option value="வேந்தன் குலம்">வேந்தன் குலம்</option>
                  <option value="கள்ளி குலம்">கள்ளி குலம்</option>
                </select>
                {renderError("kulam")}
              </div>

              <div className="form2-group">
                <label>
                  குலதெய்வம்<span className="error fs-star">*</span>
                </label>
                <input
                  type="text"
                  name="kuladeivam"
                  placeholder="குலதெய்வத்தை உள்ளிடவும்"
                  value={formData.kuladeivam}
                  onChange={handleChange}
                />
                {renderError("kuladeivam")}
              </div>

              <div className="form2-group">
                <label>
                  நட்சத்திரம்<span className="error fs-star">*</span>
                </label>
                <select
                  name="star"
                  value={formData.star}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="அஸ்வினி">அஸ்வினி</option>
                  <option value="பரணி">பரணி</option>
                  <option value="கார்த்திகை">கார்த்திகை</option>
                  <option value="ரோகிணி">ரோகிணி</option>
                  <option value="மிருகசீரிடம்">மிருகசீரிடம்</option>
                  <option value="திருவாதிரை">திருவாதிரை</option>
                  <option value="புனர்பூசம்">புனர்பூசம்</option>
                  <option value="பூசம்">பூசம்</option>
                  <option value="ஆயில்யம்">ஆயில்யம்</option>
                  <option value="மகம்">மகம்</option>
                  <option value="பூரம்">பூரம்</option>
                  <option value="உத்திரம்">உத்திரம்</option>
                  <option value="அஸ்தம்">அஸ்தம்</option>
                  <option value="சித்திரை">சித்திரை</option>
                  <option value="சுவாதி">சுவாதி</option>
                  <option value="விசாகம்">விசாகம்</option>
                  <option value="அனுஷம்">அனுஷம்</option>
                  <option value="கேட்டை">கேட்டை</option>
                  <option value="மூலம்">மூலம்</option>
                  <option value="பூராடம்">பூராடம்</option>
                  <option value="உத்திராடம்">உத்திராடம்</option>
                  <option value="திருவோணம்">திருவோணம்</option>
                  <option value="அவிட்டம்">அவிட்டம்</option>
                  <option value="சதயம்">சதயம்</option>
                  <option value="பூரட்டாதி">பூரட்டாதி</option>
                  <option value="உத்திரட்டாதி">உத்திரட்டாதி</option>
                  <option value="ரேவதி">ரேவதி</option>
                </select>
                {renderError("star")}
              </div>

              <div className="form2-group">
                <label>
                  ராசி<span className="error fs-star">*</span>
                </label>
                <select
                  name="rasi"
                  value={formData.rasi}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="மேஷம்">Mesham</option>
                  <option value="ரிஷபம்">Rishabam</option>
                  <option value="மிதுனம்">Mithunam</option>
                  <option value="கடகம்">Kadagam</option>
                  <option value="சிம்மம்">Simmam</option>
                  <option value="கன்னி">Kanni</option>
                  <option value="துலாம்">Thulam</option>
                  <option value="விருச்சிகம்">Viruchigam</option>
                  <option value="தனுசு">Thanusu</option>
                  <option value="மகரம்">Magaram</option>
                  <option value="கும்பம்">Kumbam</option>
                  <option value="மீனம்">Meenam</option>
                </select>

                {renderError("rasi")}
              </div>

              <div className="form2-group">
                <label>
                  லக்னம்<span className="error fs-star">*</span>
                </label>
                <select
                  name="laknam"
                  value={formData.laknam}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="மேஷம்">Mesham</option>
                  <option value="ரிஷபம்">Rishabam</option>
                  <option value="மிதுனம்">Mithunam</option>
                  <option value="கடகம்">Kadagam</option>
                  <option value="சிம்மம்">Simmam</option>
                  <option value="கன்னி">Kanni</option>
                  <option value="துலாம்">Thulam</option>
                  <option value="விருச்சிகம்">Viruchigam</option>
                  <option value="தனுசு">Thanusu</option>
                  <option value="மகரம்">Magaram</option>
                  <option value="கும்பம்">Kumbam</option>
                  <option value="மீனம்">Meenam</option>
                </select>
                {renderError("laknam")}
              </div>

              <div className="form2-group">
                <label>
                  உயரம்<span className="error fs-star">*</span>
                </label>
                <select
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  {[...Array(171)].map((_, i) => (
                    <option key={i} value={i + 30}>
                      {i + 30} cm
                    </option>
                  ))}
                </select>
                {renderError("height")}
              </div>

              <div className="form2-group">
                <label>
                  எடை<span className="error fs-star">*</span>
                </label>
                <select
                  name="weight"
                  value={formData.weight}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  {[...Array(171)].map((_, i) => (
                    <option key={i} value={i + 30}>
                      {i + 30} kg
                    </option>
                  ))}
                </select>
                {renderError("weight")}
              </div>

              <div className="form2-group">
                <label>
                  நிறம்<span className="error fs-star">*</span>
                </label>
                <select
                  name="colour"
                  value={formData.colour}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Very Fair">Very Fair</option>
                  <option value="Fair">Fair</option>
                  <option value="Wheatish">Wheatish</option>
                  <option value="Wheatish Brown">Wheatish Brown</option>
                  <option value="Dark">Dark</option>
                </select>

                {renderError("colour")}
              </div>

              <div className="form2-group">
                <label>
                  ஜாதகம்<span className="error fs-star">*</span>
                </label>
                <select
                  name="jathagam"
                  value={formData.jathagam}
                  onChange={handleChange}
                >
                  <option value="">தேர்ந்தெடுக்கவும்</option>
                  <option value="சுத்தம் ஜாதகம்">சுத்தம் ஜாதகம்</option>
                  <option value="செவ்வாய் ஜாதகம்">செவ்வாய் ஜாதகம்</option>
                  <option value="ராகு கேது ஜாதகம்">ராகு கேது ஜாதகம்</option>
                  <option value="சுத்தம் ராகு கேது ஜாதகம்">சுத்தம் ராகு கேது ஜாதகம்</option>
                  <option value="ராகு கேது செவ்வாய் ஜாதகம்">ராகு கேது செவ்வாய் ஜாதகம்</option>
                  <option value="பரிகார செவ்வாய் ஜாதகம்">பரிகார செவ்வாய் ஜாதகம்</option>
                </select>
                {renderError("jathagam")}
              </div>
            </div>

            <div className="form2-btn-group">
              <button type="button" className="back-btn-2" onClick={handleBack}>
                முன்செல்ல
              </button>
              <button
                type="button"
                className="submit-btn-2"
                onClick={HandleNext}
              >
                தொடர்க
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Formta2;
